import { getRequest } from '@/core';
import { incoterms } from '@/requests';

export default async function getIncotermsRequest() {
	let url = incoterms.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}